export class UomConstModal {
  id: number;
  name_key: string;
  name: string;
}
